import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newSubadmin'
})
export class NewSubadminPipe implements PipeTransform {

  transform(items: any[], filter: string): any {
    // console.log(items);
    if (!items || !filter) {
        return items;
    }
    return items.filter(item => item.email.indexOf(filter) !== -1);
  }

}
